import React from "react";

const EmptyHeader = () => {
  return <div />;
};

export default EmptyHeader;
